import {FC, ReactNode} from 'react';

import Paper, {PaperProps} from '@mui/material/Paper';

const paperStyle = () => ({
  backgroundImage: 'none',
  boxShadow: 'none',
});

interface EmpionPaperProps {
  children: ReactNode;
  sx?: any;
}

export const EmpionPaper: FC<EmpionPaperProps & PaperProps> = ({children, sx, ...props}) => {
  const style = paperStyle();

  return (
    <Paper sx={{...style, ...sx}} {...props}>
      {children}
    </Paper>
  );
};
